// extracted by mini-css-extract-plugin
export var showMore = "show-more-arrow-module--showMore--81107";